import React from "react";
import NoSearch from "./shared/NoSearch";
import PayPerViewCard from "pages/PayPerView/shared/PayPerViewCard";

function SearchPPV({ data, playlists }: any) {
  const ppvevent = data?.ppv_events || [];
  return (
    <div>
      {/* top section */}
      <div className="mb-8 w-[98%] ml-6 mt-8 max-sm:w-full max-sm:mx-0">
        <div>
          <h1 className="text-xl font-semibold text-white lg:text-xl md:text-xl">
            Payperview
          </h1>
        </div>
      </div>
      {/* card section */}
      {ppvevent.length === 0 && ppvevent ? (
        <NoSearch text="Payperview" />
      ) : (
        <div>
          <div className="mt-4 gap-4 mb-5 w-[95%] grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 max-sm:mx-auto max-sm:w-full max-sm:gap-4">
            {ppvevent.length > 0 &&
              ppvevent.map((ppvevent: any, i: any) => (
                <div key={i}>
                  <PayPerViewCard event={ppvevent} />
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default SearchPPV;
